<template>
    <div style="width:100%;heigh:100%;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- 左侧消息列表 -->
            <el-col :span="24">
                <el-card class="box-card">
                    <div style="margin-top: -10px;margin-bottom: 10px;">
                        <el-dropdown @command="handleCommandSelect">
                            <el-button type="primary">
                                <el-checkbox v-model="selectAll" @change="selectAllChange"></el-checkbox>
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="1">全选</el-dropdown-item>
                                <el-dropdown-item command="2">反选</el-dropdown-item>
                                <el-dropdown-item command="3">未读</el-dropdown-item>
                                <el-dropdown-item command="4">已读</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <el-checkbox v-model="selectAll"></el-checkbox> -->
                        <el-button type="primary" size="small" @click="deleteMsg()">删除</el-button>
                        <el-dropdown @command="handleCommand">
                            <el-button type="primary">
                                标记为<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="true">已读</el-dropdown-item>
                                <el-dropdown-item command="false">未读</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <el-table :data="tableData" ref="multipleTable" style="width: 100%" highlight-current-row @selection-change="handleSelectionChange" @row-click="getRowDate">
                        <el-table-column prop="content" label=" " min-width="50px">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.isSelect" @change="itemSelectChange($event,scope.row)"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="150px" label="模块">
                            <template slot-scope="scope">
                                <span :style="!scope.row.hasRead ? { color: '#606266' } : {}" style="margin-right:15px">{{ scope.row.title }}</span>
                                <img v-if="!scope.row.hasRead" style="height:20px;line-height:20px" src="../../../static/img/unread.png" alt="" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="content" label="内容" min-width="270">
                            <template slot-scope="scope">
                                <span style="cursor: pointer;" @click="showDetail(scope.row)">{{scope.row.content}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="gmtCreate" label="时间" :formatter="parseDate" min-width="150"></el-table-column>
                    </el-table>
                </el-card>
                <div class="box-card" style="margin-top:10px;height:90px">
                    <div class="page" v-if="tableData.length >= 0">
                        <div class="total_page">
                            <span>共{{ tableTotalPage }}条 10条/页</span>
                        </div>
                        <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                            <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-tab-pane label="异常管理" name="0"></el-tab-pane>
            <el-tab-pane label="任务进度通知" name="1"> </el-tab-pane>
            <el-tab-pane label="逐级上报通知" name="2"></el-tab-pane>
        </el-tabs>
        <edit-exception :isEdit="isEdit" :editInfo='editInfo'></edit-exception>
    </div>
</template>
<script>
import EditException from '../alarm/ExceptionList/editException.vue'
export default {
    components:{ EditException},
    name: "MessageCenter",
    data: () => {
        return {
            W: false,
            checkedList:[],
            isEdit:false,
            editInfo:{},
            selectAll:false,
            activeName: "0",
            fristLoad: false,
            btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
            tableData: [],
            tableTotalPage: 100,
            tableCurrentPage: 1,
            permission: JSON.parse(localStorage.getItem("permission")),
            ids: [],
            selectedId: [],
            propertyExtendList:[],
        };
    },

    mounted: function () {
        this.initTable();
        this.getPropertyExtendList()
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? (this.W = true) : (this.W = false);
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? (this.W = true) : (this.W = false);
        };
    },

    computed: {
        span() {
            return this.W ? 5 : 7;
        },
        hasNewMsg() {
            if (this.$store.state.hasNewMsg) {
                this.initTable(1);
                this.$store.commit("changeMsgState", false);
            }
            return this.$store.state.hasNewMsg;
        }
    },
    watch: {
        hasNewMsg(old, newMsg) {
            log(old, newMsg);
        }
    },
    methods: {
       async getPropertyExtendList(){
            let {code,data} = await this.$RequestUtil.getAsync({url: "/api/property-extend/list", type: "sync",params: {type:0}, });
            data.forEach(item=>{
                item.propertyValue = null
            })
            this.propertyExtendList = data
            // return data
        },
		async getCustomeValueList(businessOrderSplitId){
            if(businessOrderSplitId){
                let {code,data} = await this.$RequestUtil.getAsync({url: "/api/businessOrderSplitPropertyExtend/listBusinessOrderSplitPropertyExtend", type: "sync",params: {businessOrderSplitId}, });
                return data
            }
            return []
        },
		async getAllValueList(workOrderId){
			let res = await this.getCustomeValueList(workOrderId)
            
            let propertyExtendListCopy = commonUtils.cloneObj(this.propertyExtendList)
            propertyExtendListCopy.forEach(item=>{
                let index = res.findIndex(f=>f.propertyExtendId==item.id)
                if(index>-1){
                    item.propertyValue = res[index].propertyValue
                    item.isDeleted=res[index].isDeleted
                    item.oldId = res[index].id
                    res.splice(index,1)
                }
            })
            if(res.length>0){
                res.forEach(item=>{
                    propertyExtendListCopy.push({
                        id:item.propertyExtendId,
                        propertyName:item.propertyName,
                        propertyValue:item.propertyValue,
                        oldId:item.id,
                        inputType:0,
                        values:[],
                        isDeleted:item.isDeleted
                    })
                })
            }
            return propertyExtendListCopy;
		},
        goPage: function (row) {
            this.$RequestUtil.post({
                url: "/api/pushMessage/hasClick",
                type: "sync",
                params: {
                    id: row.id
                },
                success: res => { }
            });
            this.search();
            switch (row.redirectFlag) {
                case 8:
                    this.$router.push({ path: "/Warning/Warning" });
                    break;
                case 18:
                    this.$store.commit("changeWarningType", 1);
                    this.$router.push({ path: "/Warning/Warning" });
                    break;
                case 19:
                    this.$router.push({ path: "/TechnologyBOM/Technology" });
                    break;
                case 20:
                    this.$store.commit("changeOrderState", 5);
                    this.$router.push({ path: "/Production/SalesOrder" });
                    break;
                case 21:
                    this.$router.push({ path: "/Stock/RecordsOfStoreEnter" });
                    break;
                case 22:
                    this.$router.push({ path: "/Stock/RecordsOfStoreOut" });
                    break;
                case 23:
                    this.$store.commit("changeOrderState", 5);
                    this.$router.push({ path: "/Production/SalesOrder" });
                    break;
                case 24:
                    this.$router.push({ path: "/MachineInterconnection/alarmHistory" });
                    break;
            }
        },
        parseDate: function (row) {
            if (row.gmtCreate != null) {
                let tampDate = new Date(row.gmtCreate); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                let offSet = tampDate.getTimezoneOffset(); //返回格林威治时间和本地时间之间的时差，以分钟为单位。
                let tampOffSet = Math.round((480 + offSet) * 60 * 1000);
                const date = new Date(row.gmtCreate - tampOffSet);
                const Y = `${date.getFullYear()}-`;
                const M = `${date.getMonth() + 1 < 10
                        ? `0${date.getMonth() + 1}`
                        : date.getMonth() + 1
                    }-`;
                const D =
                    date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
                const h =
                    date.getHours() < 10 ? `0${date.getHours()}:` : `${date.getHours()}:`;
                const m =
                    date.getMinutes() < 10
                        ? `0${date.getMinutes()}:`
                        : `${date.getMinutes()}:`;
                const s =
                    date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
                return Y + M + D + " " + h + m + s;
            }
        },
        search: function (type) {
            let temp;
            switch (this.btnPressType) {
                case 1:
                    temp = commonUtils.cloneObj(this.searchForm);
                    this.searchFormTemp = commonUtils.cloneObj(temp);
                    break;
                case 0:
                    temp = {
                        status: "",
                        imei: ""
                    };
                    break;
                case 2:
                    temp = this.searchFormTemp;
                    break;
                case 3:
                    temp = this.searchFormTemp;
                    break;
            }
            this.$RequestUtil.get({
                url: "/api/pushMessage/listPushMessage",
                type: "sync",
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    userId: localStorage.getItem("userId"),
                    isWeb: true,
                    messageCategory:Number(this.activeName)
                },
                success: res => {
                    if (res.msg == this.$Global.RESPONSE.SUCCESS) {
                        res.data.list.forEach(item => {
                            item.isSelect = false
                            if (item.hasRead == false) {
                                this.ids.push(item.id);
                            }
                        });
                        this.selectAll = false
                        this.checkedList = []
                        this.tableData = res.data.list;
                        this.tableTotalPage = res.totalPages;
                        if (this.ids.length > 0 && !type) {
                            this.batchRead();
                        }
                        if (res.totalPages == 0 && this.fristLoad) {
                            this.$message.warning("查询不到符合条件的数据");
                        }
                        this.fristLoad = true;
                    } else {
                        this.$message.error(res.message || res.msg);
                    }
                }
            });
        },
        //去修改已读状态
        batchRead: function () {
            this.$RequestUtil.post({
                url: "/api/pushMessage/batchRead",
                type: "sync",
                params: {
                    idList: this.selectedId
                },
                success: res => {
                    if (res.msg == this.$Global.RESPONSE.SUCCESS) {
                        this.selectedId = [];
                    }
                }
            });
        },
        pageChange: function (targetPage) {
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },
        initTable: function (type) {
            this.search(type);
        },
        btnSearch: function () {
            this.tableCurrentPage = 1;
            this.btnPressType = 1;
            this.search();
        },
        async showDetail(row){
            this.editInfo = await this.loadDetail(row.redirectId)
             this.editInfo.propertyExtendList = await this.getAllValueList(this.editInfo.workOrderId)
            this.editInfo.materialInfo = this.editInfo.materialName+'|'+this.editInfo.materialCode
            if(!this.editInfo.deviceCode&&!this.editInfo.deviceName){
                this.editInfo.deviceInfo = ''
            }else{
                this.editInfo.deviceInfo = this.editInfo.deviceName+'|'+this.editInfo.deviceCode
            }
            // this.editInfo.deviceInfo = this.editInfo.deviceName+'|'+this.editInfo.deviceCode
            // this.editInfo.anomalyCode = 'procedure_starts_overdue'
            this.editInfo.dutyUserName = this.editInfo.dutyUserList.map(item=>item.userName).join(',')
            this.editInfo.dutyUserList = this.editInfo.dutyUserList.map(item=>item.userId)
            this.editInfo.fileList=[{fileId:null,fileUrl:''}]
            this.editInfo.isRead = true
            this.isEdit = true
        },

        async loadDetail(id){
            let {data,code,msg,message} = await this.$RequestUtil.getAsync({url: '/api/anomalyEvent/detail',params: {id},})
            if(code==0){
                return data
            }else{
                this.$message.error(msg||message)
            }
        },

        

        handleSelectionChange(data) {
            this.selectedId = data.map(item => item.id);
        },
        deleteMsg(rowData, index) {
            if (this.selectedId.length != 0) {
                this.$confirm(`此操作将会删除选中信息,是否继续?`, "提示", {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    
                });
            } else {
                this.$message.warning("请选择需要删除的消息！");
            }
        },
        handleCommandSelect(type){
            if(type==1){   //type  1-全选 2-反选 3-未读 4-已读
                let idList = []
                this.tableData.forEach(item=>{
                    item.isSelect = true
                    idList.push(item.id)
                })
                this.checkedList = idList
            }else if(type==2){
                let idList = []
                this.tableData.forEach(item=>{
                    item.isSelect = !item.isSelect
                    if(item.isSelect){
                        idList.push(item.id)
                    }
                })
                this.checkedList = idList
            }else if(type==3){
                let idList = []
                this.tableData.forEach(item=>{
                    if(!item.hasRead){
                        item.isSelect = true
                        idList.push(item.id)
                    }else{
                        item.isSelect = false
                    }
                })
                this.checkedList = idList
            }else if(type==4){
                let idList = []
                this.tableData.forEach(item=>{
                    if(item.hasRead){
                        item.isSelect = true
                        idList.push(item.id)
                    }else{
                        item.isSelect = false
                    }
                })
                this.checkedList = idList
            }
            if(this.checkedList.length>0){
                this.selectAll = true
            }else{
                this.selectAll = false
            }
            let data = commonUtils.cloneObj(this.tableData)
            this.tableData = data
        },

        selectAllChange(ev){
            if(ev){
                let idList = []
                this.tableData.forEach(item=>{
                    item.isSelect = true
                    idList.push(item.id)
                })
                this.checkedList = idList
            }else{
                this.tableData.forEach(item=>{
                    item.isSelect = false
                })
                this.checkedList = []
            }
            let data = commonUtils.cloneObj(this.tableData)
            this.tableData = data
        },

        itemSelectChange(ev,row){
            if(ev){
                if(!this.checkedList.includes(row.id)){
                    this.checkedList.push(row.id)
                }
                this.selectAll = true
            }else{
                if(this.checkedList.includes(row.id)){
                    this.checkedList = this.checkedList.filter(item=>item!=row.id)
                    if(this.checkedList.length==0){
                        this.selectAll = false
                    }
                }
            }
        },

        handleCommand(command) {
            if (this.selectedId.length != 0) {
                let tableList = this.tableData;
                this.selectedId.forEach(item => {
                    tableList.forEach(itemI => {
                        if (item === itemI.id) {
                            itemI.hasRead = command;
                        }
                    });
                });
                this.tableData = tableList;
                this.$refs.multipleTable.clearSelection();
            } else {
                this.$message.warning("请选择需要标记的消息！");
            }
        },
        // 点击当某一行被点击时会触发该事件
        getRowDate(row) {
            console.log(row);
        },
        handleClick(ev) { 
            this.search()
        }
    }
};
</script>
<style scoped>
.mouseOn {
    color: #606266;
}
.mouseOn:hover {
    color: #409fff;
}

.point {
    width: 8px;
    height: 8px;
    background: red;
    border-radius: 100%;
    display: inline-block;
}
.table_searchbar {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.addForm .value {
    display: inline-block;
    width: 280px;
    text-align: center;
}
.addForm .title {
    width: 70px;
    text-align: right;
    display: inline-block;
}
.page {
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1380px) {
    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
}
.total_page {
    margin-top: 20px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/masterdata/MessageCenter.vue